import { HERO_GEN } from "./hero_gen";

// Landing hero copy — FR is the source of truth; other languages generated from it.
const FR = {
  badge: "Disponible dans 22 langues • Conçu pour les éleveurs européens",
  title: "Pilotez toute votre exploitation depuis une seule plateforme.",
  subtitle: "Gérez vos animaux, vos productions, vos ventes, vos stocks, votre comptabilité et vos clients depuis une seule plateforme, disponible en 22 langues et adaptée aux éleveurs de toute l'Europe.",
};

const H = { fr: FR, ...(HERO_GEN || {}) };

export function heroText(lang) {
  return H[lang] || H.fr;
}
